import React from 'react'
import './Portfolio.css'
import Projects from './Projects'
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useEffect } from 'react';


const Portfolio = () => {

  const { ref, inView } = useInView({
    threshold: 0.1, // Trigger animation when the component is at least 50% visible
    triggerOnce: false // Trigger animation every time the component comes into view
  });

  // Use `useAnimation` to trigger the animation
  const animation = useAnimation();

  // Define the animation
  const leftVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1.5 , ease: 'easeInOut' } }
  };
  const topVariants = {
    hidden: { opacity: 0, y: -30 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } }
  };

  

  // Use `useEffect` to trigger the animation when the component comes into view
  useEffect(() => {
    if (inView) {
      animation.start('visible');
    } else {
      animation.start('hidden');
    }
  }, [inView]);





  return (
    <section id='Portfolio' className='portfolio__main'>
      <motion.div variants={topVariants} 
          initial="hidden"
          animate={animation} ref={ref}
          className='port__color' > 
        <h4>portoflio</h4>  
        <h2>Web Projects</h2>
        </motion.div>
        <div className="container portfolio__container" >
          <Projects/>
        </div>
    </section>  
  )
}

export default Portfolio